import TableHead from "./TableHead"
import TableRow from "./TableRow"

export default function ReservationsTable({ reservations, getReservations, sortBy, setSortBy }) {
    return <div className="table">
        <TableHead getReservations={getReservations} sortBy={sortBy} setSortBy={setSortBy} />
        <div className="t-body">
            {reservations.map((e, i) => {
                return <TableRow e={e} i={i} key={i} />
            })}
        </div>
    </div>
}